module.exports = __webpack_public_path__ + "img/ico-briefcase.50d6c8ac.svg";